/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Col, Row } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import prettyBytes from 'pretty-bytes'

import {AppContext} from '../AppContext';

class ResourceUtilization extends React.Component
{
  ColumnKey = 'userManagement.existingObjects.columnWidths';
  deletedColumnKey = 'userManagement.deletedObjects.columnWidths';
  debouncedSaveColumnWidths = null;
  existingSortColumnKey = 'userManagement.existingObjects.sortColumn';
  deletedSortColumnKey = 'userManagement.deletedObjects.sortColumn';
  existingColumnWidths = {};
  deletedColumnWidths = {};

  async componentDidMount()
  {
    this.existingColumnWidths = this.context.appLocalStorage.getColumnWidths(this.state.existingColumns, this.existingColumnKey);
    this.deletedColumnWidths = this.context.appLocalStorage.getColumnWidths(this.state.deletedColumns, this.deletedColumnKey);

    let existingSortColumn = JSON.parse(this.context.appLocalStorage.getItem(this.existingSortColumnKey))
    if (null === existingSortColumn) existingSortColumn = undefined;

    let deletedSortColumn = JSON.parse(this.context.appLocalStorage.getItem(this.deletedSortColumnKey))
    if (null === deletedSortColumn) deletedSortColumn = undefined;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getResourceUtilizationData');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving resource utilization data');
    this.setState(
    { 
      existingSortcolumn: existingSortColumn, 
      deletedSortColumn: deletedSortColumn,
      totalUtilization: result.jsonData.totalUtilization,
      existingObjects: result.jsonData.existingObjects,
      deletedObjects: result.jsonData.deletedObjects
    });
  }

  constructor(props)
  {
    super();

    const columns =
    [
      {Header: 'Object Type', id: 'objectType', accessor: 'objectType'},
      {Header: '# of Items', id: 'numberOfItems', accessor: 'itemCount',
        Cell: row => (<div>{new Intl.NumberFormat().format(row.value)}</div>),
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      },
      {Header: 'Bytes Used', id: 'bytesUsed', accessor: 'byteTotal',
        Cell: row => (<div>{ prettyBytes(row.value, 10) }</div>),
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      }        
    ];

    let existingColumns = columns;
    let deletedColumns = columns;

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.state =
    {
      existingSortColumn: undefined,
      deletedSortColumn: undefined,
      existingColumns: existingColumns,
      deletedColumns: deletedColumns,
      totalUtilization: undefined,
      existingObjects: undefined,
      deletedObjects: undefined
    }
  }

  render()
  {
    let itemCount = (undefined !== this.state.totalUtilization ? new Intl.NumberFormat().format(this.state.totalUtilization.itemCount) : '');
    let totalUsage = (undefined !== this.state.totalUtilization ? '- ' +  prettyBytes(this.state.totalUtilization.totalUsage, 10) : '');
    
    return(
      <div>
        <Row style={{paddingTop: "10px" }}>
          <Col sm='4'>
            Total # of Objects: {itemCount} {totalUsage}
          </Col>
        </Row>
        <Row style={{paddingTop: "10px" }}>
          <Col sm='6'>Existing Objects</Col><Col sm='6'>Deleted Objects</Col>
        </Row>
        <Row>
          <Col sm='6'>
            <ReactTable data={this.state.existingObjects} columns={this.state.existingColumns} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event, 'existing')} 
              defaultSorted={this.state.existingSortColumn} onSortedChange={this.sortChanged.bind(this, 'existing')}
            />
          </Col>
          <Col sm='6'>
            <ReactTable data={this.state.deletedObjects} columns={this.state.deletedColumns} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event, 'deleted')} 
              defaultSorted={this.state.deletedSortColumn} onSortedChange={this.sortChanged.bind(this, 'deleted')}
            />
          </Col>
        </Row>
      </div>
    );
  }

  saveColumnWidths(resizedColumns, event, type)
  {
    if ('existing' === type)
      this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.existingColumnWidths, this.existingColumnKey);
    else
      this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.deletedColumnWidths, this.deletedColumnKey);
  }

  sortChanged(type, sortColumn, object, shiftKey)
  {
    if ('existing' === type)
      this.context.appLocalStorage.setItem(this.existingSortColumnKey, JSON.stringify(sortColumn));
    else
      this.context.appLocalStorage.setItem(this.deletedSortColumnKey, JSON.stringify(sortColumn));
  }
}

ResourceUtilization.contextType = AppContext;

export default ResourceUtilization  